{
  "schema_version": 1,
  "task_id": "L5-RUNTIME-PREVIEW-TRUST-001",
  "status": "runtime-preview-trust-ready",
  "source_entry_point": "runtime-preview-trust",
  "generated_at": "2026-07-31T07:25:00+08:00",
  "authority_boundary": {
    "observational_only": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "tool_call": false,
    "tauri_command_invocation": false,
    "formal_task_write": false,
    "task_completion_authority": false
  },
  "summary": {
    "trust_cue_count": 5,
    "stop_condition_count": 4,
    "receipt_signal_count": 4,
    "can_execute_now_count": 0,
    "tauri_command_invocation_count": 0,
    "formal_task_write_count": 0,
    "external_effect_count": 0,
    "secret_values_embedded_count": 0,
    "remaining_user_decision_count": 3,
    "visible_capability": "desktop-runtime-preview",
    "adds_new_visible_capability": false
  },
  "title_zh": "Runtime 预览可信，但不是执行",
  "title_en": "Runtime preview is trustworthy, but not execution",
  "body_zh": "AIOS 会把候选动作、权限账本、Evidence、回滚和 Reviewer 放进 Preview Lab，让用户先看懂风险；但在明确授权、Task Spec、Reviewer 和正式 Gate 前，预览不会调用 Tauri command、写正式任务或产生外部副作用。",
  "body_en": "AIOS places candidate actions, permission ledger, Evidence, rollback and Reviewer requirements into Preview Lab so users can understand risk first; before explicit authorization, Task Spec, Reviewer and formal Gates, preview does not invoke Tauri commands, write formal tasks or create external effects.",
  "trust_cues": [
    {
      "id": "preview_only",
      "label_zh": "preview-only",
      "label_en": "preview-only",
      "explanation_zh": "显示候选动作与风险，不代表已经执行。",
      "explanation_en": "Shows candidate actions and risk; does not mean execution happened."
    },
    {
      "id": "no_tauri_command",
      "label_zh": "不调用 Tauri command",
      "label_en": "No Tauri command",
      "explanation_zh": "当前没有跨过 IPC 到系统级动作。",
      "explanation_en": "Current preview does not cross IPC into system-level actions."
    },
    {
      "id": "no_formal_task_write",
      "label_zh": "不写正式任务",
      "label_en": "No formal task write",
      "explanation_zh": "只生成可读草稿，不替用户登记正式完成态。",
      "explanation_en": "Generates readable drafts only; does not register formal completion state."
    },
    {
      "id": "receipt_draft_only",
      "label_zh": "receipt 草稿只读",
      "label_en": "Receipt draft only",
      "explanation_zh": "receipt 用于解释，不作为正式审批凭证。",
      "explanation_en": "Receipt explains the preview; it is not a formal approval credential."
    },
    {
      "id": "reviewer_before_effect",
      "label_zh": "Reviewer 先于副作用",
      "label_en": "Reviewer before effects",
      "explanation_zh": "任何真实副作用前都要有 Evidence、回滚和独立审查。",
      "explanation_en": "Any real side effect requires Evidence, rollback and independent review first."
    }
  ],
  "stop_conditions": [
    {
      "id": "explicit_user_go_missing",
      "label_zh": "缺少 explicit_user_go",
      "label_en": "Missing explicit_user_go"
    },
    {
      "id": "evidence_missing",
      "label_zh": "缺少 Evidence",
      "label_en": "Missing Evidence"
    },
    {
      "id": "reviewer_missing",
      "label_zh": "缺少 Reviewer",
      "label_en": "Missing Reviewer"
    },
    {
      "id": "rollback_missing",
      "label_zh": "缺少回滚方案",
      "label_en": "Missing rollback plan"
    }
  ],
  "receipt_signals": [
    {
      "id": "state_write",
      "label": "state_write",
      "value": 0
    },
    {
      "id": "tauri_command_invocations",
      "label": "tauri_command_invocations",
      "value": 0
    },
    {
      "id": "formal_task_writes",
      "label": "formal_task_writes",
      "value": 0
    },
    {
      "id": "external_effect_count",
      "label": "external_effect_count",
      "value": 0
    }
  ],
  "guardrails": [
    "preview_only",
    "no_tauri_command",
    "no_formal_task_write",
    "no_external_write",
    "no_runtime_activation",
    "no_secret_collection",
    "no_model_call",
    "reviewer_before_effect"
  ],
  "quality_gates": [
    "Task Spec",
    "Evidence",
    "Reviewer",
    "Rollback",
    "lint/build/test",
    "no external effect"
  ],
  "handoff_integration": {
    "visible_capability": "desktop-runtime-preview",
    "evidence": "artifacts/evidence/L5-RUNTIME-PREVIEW-TRUST-001",
    "project_status": "config/aios-project-status.json",
    "final_handoff_pack": "config/l5-final-handoff-pack.json",
    "completion_map": "config/l5-completion-map.json"
  }
}
